"use strict";

const $ = jQuery;
const Vimeo = require('./vimeo-player-2.25.0.js');
const LumerisModal = require('./lumeris-modal.js');

module.exports = class {
	#$module;
    #$modal;
    #$triggers;

    #modal;
    #player;
	#data = {};
    #vimeoData = {};

	initialized = false;
    activeTrigger = null;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$triggers = $('body').find('[data-lumeris-vimeo-modal="' + data.settings.modal_id + '"]');

        const videoUrl = `https://vimeo.com/${data.settings.video_id}`;
        const endpoint = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;

        fetch(endpoint).then((response) => {
            if (!response.ok) {
                throw new Error(`Error fetching Vimeo oEmbed data: ${response.status}`);
                return {};
            }
            return response.json();
        }).then((data) => {
            this.#vimeoData = data;
            this.build();
        });

		this.bind();

		this.initialized = true;
	}

	bind() {	
        this.$triggers.on('click', (event) => { this.onTriggerClick(event); });	
	}

    modalBind() {
        if (!this.modal) {
            return null;
        }

        this.modal.on('lumeris-modal:cancelButtonClick', (event) => { this.onCancelButtonClick(event); });
    }

    build() {
        this.modal = new LumerisModal({
            id: this.data.settings.modal_id ?? this.id  + '-vimeo-modal',
            modalClass: 'lum-vimeo-modal ' + this.data.settings.modal_classes ,
            header: this.data.settings.modal_header,
            cancelButton: true,
			destroyOnCancel: false
        });

        // id: 'lumeris-modal',
        // modalClass: '',
        // modalHeaderClass: '',
        // header: null,
        // headerClass: '',
        // subheader: null,
        // subheaderClass: '',
        // modalBodyClass: '',
        // button: null,
        // buttonClass: '',
        // buttonDisabled: false,
        // altButton: '',
        // altButtonClass: 'no-style',
        // altButtonDisabled: false,
        // modalFooterClass: '',
        // cancelButton: true,
        // backdropClass: '',
        // destroyOnCancel: true
        
        this.$modal = $(this.modal);
        const $content = $(this.data.settings.modal_body_content);
        const $vimeo = $('<div>');

        if (this.vimeoData.html) {
            const ratio = Math.round((this.vimeoData.width / this.vimeoData.height) * 100);
            const ratioClass = (ratio == 178) ? 'ratio-16x9' : 'ratio-4x3';
            const $iframe = $(this.vimeoData.html);
            // .attr('sandbox', 'allow-scripts allow-same-origin allow-presentation');
            $iframe.attr('allow', `${$iframe.attr('allow')}; presentation`);
            
            $vimeo.addClass(`vimeo-container ${ratioClass}`).append($iframe);
        } else {
            $vimeo.addClass('video-not-available').append(this.data.settings.video_not_available_message);
        }

        this.player = ($vimeo.length == 0) ? null : new Vimeo($vimeo.get(0));

		this.modal.prependBodyContent($vimeo);
        this.modal.appendBodyContent($content);

        this.modalBind();
    }

    get $module() {
        return this.#$module;
    }

    get $modal() {
        return this.#$modal;
    }

    get $triggers() {
        return this.#$triggers;
    }

    get modal() {
        return this.#modal;
    }

    get player() {
        return this.#player;
    }

    get vimeoData() {
        return this.#vimeoData;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.node;
    }

    set $module(val) {
        this.#$module = val;
    }

    set $modal(val) {
        this.#$modal = val;
    }

    set $triggers(val) {
        this.#$triggers = val;
    }

    set modal(val) {
        this.#modal = val;
    }

    set player(val) {
        this.#player = val;
    }

    set data(val={}) {
        this.#data = val;
    }

    set vimeoData(val={}) {
        this.#data = val;
    }

    onTriggerClick(event) {
		if (event instanceof Object === false) {
			return null;
		}

        event.preventDefault();
        
        if (!this.modal) {
            this.build();
        }

        this.activeTrigger = $(event.target);

        return this.modal.show();
    }

    onCancelButtonClick(event) {
		if (event instanceof Object === false) {
			return null;
		}

        if (this.activeTrigger) {
            this.activeTrigger.focus();
        }

        if (this.player) {
            this.player.pause();
        }
	}
}